import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { makeStyles } from '@material-ui/core';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Input from '../Input';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '100%',
    '& .MuiFilledInput-root': {
      alignItems: 'flex-start',
    },
    '& textarea': {
      whiteSpace: 'pre-wrap',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      overflowX: 'hidden',
      overflowY: 'hidden',
      resize: 'none',
    },
  },
}), { name: 'TextInput' });

function TextInput({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  const shouldWrapValue = (text: string): boolean => {
    if (!text) return false;

    const CHARS_PER_ROW_ESTIMATE = 55;
    return text.includes('\n') || text.length > CHARS_PER_ROW_ESTIMATE;
  };

  const getRowsForValue = (text: string): number => {
    if (!text) return 1;

    const CHARS_PER_ROW_ESTIMATE = 55;
    const explicitLineCount = text.split('\n').length;
    const estimatedLineCount = Math.ceil(text.length / CHARS_PER_ROW_ESTIMATE);

    return Math.max(1, explicitLineCount, estimatedLineCount);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => {
        const normalizedValue = value || '';
        const shouldWrap = shouldWrapValue(normalizedValue);

        return (
          <Input 
              className={classes.textField} 
              label={label}
              value={normalizedValue}
              multiLine={shouldWrap}
              rows={shouldWrap ? getRowsForValue(normalizedValue) : 1}
              onChange={onChange}
          />
        );
      }}
    />
  );
}

export default memo(TextInput);
